/**
 * CrispNodeContent — wrapper that re-rasterizes DAG node HTML at display resolution.
 *
 * Uses CSS `zoom` (re-rasterizes at target resolution) paired with a counter
 * `transform: scale(1/zoom)` so the node's bounding box stays correct for
 * React Flow layout and edge routing.  The `--rf-zoom` CSS variable is set by
 * ZoomBridge and propagated through CSS inheritance — no React re-renders on
 * zoom change.
 *
 * Handles must be rendered **outside** this wrapper so their positions remain
 * accurate for edge connections.
 */

import type { CSSProperties, ReactNode } from "react";

type Dimension = number | string;

interface CrispNodeContentProps {
  width: Dimension;
  height: Dimension;
  children: ReactNode;
  style?: CSSProperties;
}

export function CrispNodeContent({ width, height, children, style }: CrispNodeContentProps) {
  return (
    <div style={{ width, height, overflow: "hidden", position: "relative", ...style }}>
      <div className="dag-crisp-inner" style={{ width, height }}>
        {children}
      </div>
    </div>
  );
}
